import { TYPE_OF_DAMAGE } from '@/api/types';
import { ConditionalRender } from '@/components/ui/ConditionalRender';
import { TYPE_OF_DAMAGE_NAME } from '@/features/v2/vehicle-damage/components/RadioGroupTypeOfDamage';
import { FullACUploader } from '@/features/v2/vehicle-damage/surveys/Documents/FullAC';
import { FullOCUploader } from '@/features/v2/vehicle-damage/surveys/Documents/FullOC';
import { PartACUploader } from '@/features/v2/vehicle-damage/surveys/Documents/PartAC';
import { PartOCUploader } from '@/features/v2/vehicle-damage/surveys/Documents/PartOC';

export const Documents = () => {
  return (
    <>
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.PART_OC}
      >
        <PartOCUploader />
      </ConditionalRender>
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.FULL_OC}
      >
        <FullOCUploader />
      </ConditionalRender>
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.PART_AC}
      >
        <PartACUploader />
      </ConditionalRender>
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.FULL_AC}
      >
        <FullACUploader />
      </ConditionalRender>
    </>
  );
};
